import PropTypes from 'prop-types';

import { Label, Col, FormGroup, Input } from "twyne-new.ui";

const propTypes = {
  label: PropTypes.string,
  sm: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
}

export default function TabItem({ label, value, sm = 6 }) {
  return <Col size={sm}>
    <FormGroup>
      <Label className='capitalize'>{label}</Label>
      <Input readOnly value={value || '--'} />
    </FormGroup>
  </Col>
}

TabItem.propTypes = propTypes
TabItem.defaultProps = {
  sm: 6,
  isBreakWord: false,
}
